module.exports = __webpack_public_path__ + "static/media/workingmemory-words-11.d4ac6a79.mp3";